import { SingleSelect } from "ui-components/Select";

import DataFileTypes from "modules/data-files/elements/Data-File-Types-Modal";

import Columns from "./Columns";
import NoExistingData from "./No-Existing-Data";

import useFetchFiles from "./fetch-files";

interface Props {
  selected?: string;
  onChange: (fileId: string) => any;
  label?: React.ReactNode;
  name?: string;
  help?: React.ReactNode;
  enableTypeSelection?: boolean;
  enableDrop?: boolean;
  excluded?: string[];
}

const SelectDataFile = ({
  selected,
  onChange,
  label,
  name = "selectFile",
  help,
  enableTypeSelection,
  enableDrop,
  excluded,
}: Props) => {
  const { data, status } = useFetchFiles();

  if (status === "loading") {
    return null;
  }

  if (data.flat().length === 0) {
    return <NoExistingData />;
  }

  const options = data
    .flat()
    .filter((d) => !excluded?.includes(d.id))
    .map((d) => ({
      value: d.id,
      label: `${
        d.name || d.id
      } (${d.row_count.toLocaleString()} rows and ${d.col_count.toLocaleString()} columns. Created on ${new Date(
        d.created_time
      ).toDateString()})`,
    }));

  const selectedFile = data
    .find((l) => l.map((d) => d.id).includes(selected || ""))
    ?.find((d) => d.id === selected);

  return (
    <div className="flex mt-2">
      {label && (
        <div className="w-1/4">
          <label htmlFor={name} className="font-bold">
            {label}
          </label>
        </div>
      )}
      <div className="w-full">
        <SingleSelect
          name={name}
          options={options}
          selected={selected || null}
          onChange={onChange}
          placeholder="Select a File"
        />
        {enableTypeSelection && selectedFile && (
          <DataFileTypes
            fileId={selected}
            modalClickElem={
              <p className="text-primary-main cursor-pointer underline text-right">
                Change Column Types
              </p>
            }
            enableDrop={enableDrop}
          />
        )}
        {selectedFile && <Columns selectedFile={selectedFile} />}
        {help && <div className="text-sm text-gray-700">{help}</div>}
      </div>
    </div>
  );
};

export default SelectDataFile;
